<template>
  <div class="licenseDetail">
    <!-- 头部导航 -->
    <div class="topBar">
      <div class="topBar-content">
        <div class="topBar-content-left">
          <span @click="$router.push('/foodLicense/home')" style="cursor: pointer;">智能化检索</span>
        </div>
        <!-- <div class="topBar-content-right">
          <a>登录</a>
          <img src="@/assets/imgs/foodLicense/分割线.png" alt />
          <a>免费注册</a>
        </div> -->
      </div>
    </div>
    <!-- 当前位置 -->
    <div class="currentPosition">
      <span>当前位置:</span>
      <span @click="$router.go(-1)" style="cursor: pointer;">常规检索></span>
      <span style="color:#139EFF;">食品经营许可证详情</span>
    </div>
    <!-- 详情信息 -->
    <div class="detail">
      <div class="img"></div>
      <div class="detail-top">
        <h3>{{licenseInfo.company_name||'--'}}</h3>
        <div class="top-content">
          <div class="top-left">
            <p>
              <span class="lableName">企业法人:</span>
              <span class="lableValue">{{licenseInfo.legal_person||'--'}}</span>
            </p>
            <p>
              <span class="lableName">许可证编号:</span>
              <span class="lableValue">{{licenseInfo.license_no||'--'}}</span>
            </p>
          </div>
          <div class="top-right">
            <p>
              <span class="lableName">社会统一信用代码:</span>
              <span class="lableValue">{{licenseInfo.scc_icn||'--'}}</span>
            </p>
            <p>
              <span class="lableName">所属地区:</span>
              <span class="lableValue">{{licenseInfo.base||'--'}}</span>
              <span class="lableName" style="margin-left:88px;">当前状态:</span>
              <span
                class="lableValue"
                style="color:#139EFF;"
              >{{licenseInfo.status===1?'有效':licenseInfo.status===0?'失效':'--'}}</span>
            </p>
          </div>
        </div>
        <div class="licenseRead">
          <p>食品许可证解读:</p>
          <div class="tips1">
            <span>三证合一（北京地区）：</span>
            <span>《食品流通许可证》、《餐饮服务许可证》、《食品卫生许可证》</span>
          </div>
          <div class="line"></div>
          <div class="tips2">
            <span>注意事项：</span>
            <span>名称变更、法人变更、主体业态变更等请及时进行食品经营许可证变更</span>
            <a
              class="toChange"
              href="https://www.gongsibao.com/st/chengfenjc/spltxk/index.html"
              target="view_window"
            >
              去变更
              <img
                src="@/assets/imgs/foodLicense/jiantou-4.png"
                alt
                style="width:8px;height:13px;display:inline-block;margin-left:10px;"
              />
            </a>
          </div>
        </div>
      </div>
      <!-- 进度条 -->
      <div class="detail-middle">
        <div class="step">
          <img
            class="step-icon"
            :src="currentTime>=new Date(tableInfo.create_time).getTime()?require('@/assets/imgs/foodLicense/申请.png'):require('@/assets/imgs/foodLicense/停止.png')"
            alt
          />
          <div
            :class="currentTime>=new Date(tableInfo.pub_date).getTime()?'step-line active':'step-line'"
          ></div>
          <img
            class="step-icon"
            :src="currentTime>=new Date(tableInfo.pub_date).getTime()?require('@/assets/imgs/foodLicense/申请.png'):require('@/assets/imgs/foodLicense/停止.png')"
            alt
          />
          <div
            :class="currentTime>=new Date(tableInfo.end_date).getTime()?'step-line active':'step-line'"
          ></div>
          <img
            class="step-icon"
            :src="currentTime>=new Date(tableInfo.end_date).getTime()?require('@/assets/imgs/foodLicense/申请.png'):require('@/assets/imgs/foodLicense/停止.png')"
            alt
          />
        </div>
        <div class="step-word">
          <div class="word-left">
            <p>申请</p>
            <p class="word-time"></p>
          </div>
          <div class="word-middle">
            <p>获证</p>
            <p class="word-time">{{tableInfo.pub_date||'--'}}</p>
          </div>
          <div class="word-right">
            <p>终止</p>
            <p class="word-time">{{tableInfo.end_date||'--'}}</p>
          </div>
        </div>
      </div>
      <!-- 底部表格 -->
      <div class="detail-bottom">
        <table>
          <tr>
            <td>
              <span class="infoName">经营者名称</span>
              <span class="infoValue">{{tableInfo.company_name||'--'}}</span>
            </td>
            <td>
              <span class="infoName">许可证编号</span>
              <span class="infoValue">{{tableInfo.license_no||'--'}}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span class="infoName">主体业态</span>
              <span class="infoValue">{{tableInfo.subject_format||'--'}}</span>
            </td>
            <td>
              <span class="infoName">经营场所</span>
              <span class="infoValue">{{tableInfo.business_place||'--'}}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span class="infoName">发证机关</span>
              <span class="infoValue">{{tableInfo.issuing_authority||'--'}}</span>
            </td>
            <td>
              <span class="infoName">发证日期</span>
              <span class="infoValue">{{tableInfo.pub_date||'--'}}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span class="infoName">有效期至</span>
              <span class="infoValue">{{tableInfo.end_date||'--'}}</span>
            </td>
            <td>
              <span class="infoName">状态</span>
              <span class="infoValue">{{tableInfo.status===1?'有效':tableInfo.status===0?'失效':'--'}}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span class="infoName">投诉举报电话</span>
              <span class="infoValue">{{tableInfo.tsjbdh||'--'}}</span>
            </td>
            <td>
              <span class="infoName">日常监督管理人员</span>
              <span class="infoValue">{{tableInfo.manage_person||'--'}}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span class="infoName">签发人</span>
              <span class="infoValue">{{tableInfo.signer||'--'}}</span>
            </td>
            <td>
              <span class="infoName">日常监督管理机构</span>
              <span class="infoValue">{{tableInfo.manage_agency||'--'}}</span>
            </td>
          </tr>
          <tr style="height:180px;">
            <td class="jingyingItem" colspan="2" style="height:180px;">
              <span class="infoName" style="height:180px;line-height:180px;">经营项目</span>
              <span
                class="infoValue"
                style="height:180px;display:flex;width:940px;flex-wrap:wrap;flex-direction:column;justify-content:space-evenly;"
              >
              <p v-show="business_items.length<=0" style="text-align:left;">--</p>
                <p
                  v-show="business_items.length>0"
                  v-for="item in business_items"
                  :key="item"
                  class="bussinessItem"
                  style="height:25px;width:900px;"
                >
                  {{item}}
                  <b>;</b>
                </p>
                
              </span>
            </td>
          </tr>
          <tr>
            <td>
              <span class="infoName">签发人</span>
              <span class="infoValue">{{tableInfo.signer||'--'}}</span>
            </td>
            <td>
              <span class="infoName">日常监督管理机构</span>
              <span class="infoValue">{{tableInfo.manage_agency||'--'}}</span>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { getDetail } from "@/api/foodLicense.js";
export default {
  data() {
    return {
      //许可证主键
      id: "",
      // 当前时间时间
      currentTime: "",
      // 表单数据
      licenseInfo: {
        //公司名
        company_name: "--",
        // 企业法人
        legal_person: "--",
        // 许可证编号
        license_no: "--",
        // 社会统一信用代码
        scc_icn: "--",
        //所属地区
        base: "--",
        //当前状态
        status: "",
      },
      // 表格数据
      tableInfo: {
        // 经营者名称
        company_name: "--",
        // 许可证编号
        license_no: "--",
        // 主题业态
        subject_format: "--",
        // 经营场所
        business_place: "--",
        // 发证机关
        issuing_authority: "--",
        //发证日期
        pub_date: "--",
        //有效期至
        end_date: "--",
        //状态
        status: "--",
        //投诉举报电话
        tsjbdh: "--",
        //日常监督管理人员
        manage_person: "--",
        //签发人
        signer: "--",
        //日常监督管理机构
        manage_agency: "--",
        //经营项目
        business_items: "--",
        // 创建(申请)日期
        create_time: "",
      },
    };
  },
  computed: {
    business_items() {
      let itemList = [];
      if(this.tableInfo.business_items){
        return (itemList = this.tableInfo.business_items.split("；"));
      }else{
        return itemList
      }
    },
  },
  methods: {
    // 获取当前时间
    getCurrentTime() {
      let timeStr = new Date();
      let currentYear = timeStr.getFullYear();
      let currentMonth = (timeStr.getMonth() + 1).toString().padStart(2, 0);
      let currentDate = timeStr.getDate().toString().padStart(2, 0);
      this.currentTime = new Date(
        currentYear + "-" + currentMonth + "-" + currentDate
      ).getTime();
    },
    // 获取许可证信息
    getDetailInfo() {
      let params = {
        id: this.id || "",
      };
      getDetail(params).then((res) => {
        if (res.code === 0) {
          if (res.data) {
            this.licenseInfo = { ...res.data };
            this.tableInfo = { ...res.data };
            this.tableInfo.tsjbdh = '12315'
          }else{
            this.$message.error('未查询到数据！')
          }
        }else{
          this.$message.error('数据请求失败！')
        }
      });
    },
  },
  created() {
    this.id = this.$route.query.id;
    this.getDetailInfo();
    this.getCurrentTime();
  },
};
</script>
<style lang="scss" scoped>
.licenseDetail {
  width: 100%;
  height: auto;
  background-color: #f2f5f8;
  .topBar {
    width: 100%;
    height: 50px;
    background: rgba(19, 158, 255, 1);
    .topBar-content {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      line-height: 50px;
      justify-content: space-between;
      span {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        display: inline-block;
        color: white;
      }
      .topBar-content-right {
        display: flex;
        align-items: center;
        img {
          margin: 0 15px;
        }
        a {
          cursor: pointer;
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
        }
      }
    }
  }
  .currentPosition {
    margin: 0 auto;
    width: 1200px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(55, 58, 60, 1);
    height: 50px;
    line-height: 50px;
  }
  .detail {
    margin: 0 auto;
    width: 1200px;
    .img {
      width: 128px;
      height: 150px;
      background-image: url("../../../assets/imgs/foodLicense/company.png");
      background-size: cover;
      float: right;
      right: 0;
      top: 0;
    }
    .detail-top {
      width: 100%;
      background-color: #ffffff;
      padding: 50px 50px 36px 50px;
      h3 {
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(55, 58, 60, 1);
        margin-bottom: 7px;
      }
      .top-content {
        display: flex;
        p {
          margin-top: 16px;
          .lableName {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(116, 116, 116, 1);
          }
          .lableValue {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #373a3c;
            display: inline-block;
            margin-left: 5px;
          }
        }
        .top-left {
          width: 40%;
        }
      }
      .licenseRead {
        width: 1100px;
        height: 146px;
        margin-top: 36px;
        background-color: #f3faff;
        padding: 18px 20px 22px;
        p {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(116, 116, 116, 1);
          margin-bottom: 15px;
        }
        span {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(55, 58, 60, 1);
        }
        .line {
          width: 100%;
          height: 1px;
          background: rgba(255, 255, 255, 1);
          margin-top: 13px;
          margin-bottom: 13px;
        }
        a {
          float: right;
          font-size: 16px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(19, 158, 255, 1);
          line-height: 22px;
        }
        .toChange {
          cursor: pointer;
        }
      }
    }
    .detail-middle {
      margin-top: 10px;
      width: 100%;
      height: 234px;
      padding-top: 50px;
      background-color: #fff;
      .step {
        margin: 0 auto;
        width: 680px;
        height: 70px;
        background-image: url("../../../assets/imgs/foodLicense/进度条.png");
        .step-icon {
          width: 54px;
          height: 54px;
          display: inline-block;
          position: relative;
          top: 8px;
          left: 8px;
        }
        .step-line {
          width: 251px;
          height: 4px;
          background-color: none;
          display: inline-block;
          position: relative;
          top: -17px;
          left: 8px;
          &.active {
            background-color: #139eff;
          }
        }
      }
      .step-word {
        margin: 18px auto;
        width: 718px;
        height: 70px;
        display: flex;
        justify-content: space-between;
        div {
          width: 100px;
          text-align: center;
          font-size: 16px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(55, 58, 60, 1);
          .word-time {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(55, 58, 60, 1);
            margin-top: 4px;
          }
        }
      }
    }
    .detail-bottom {
      margin-top: 10px;
      width: 100%;
      background-color: #fff;
      padding: 50px 0;
      table {
        width: 1120px;
        border: 2px solid #e4eaf2;
        margin: 0 auto;
        tr {
          width: 100%;
          td {
            width: 50%;
            border: 1px solid #e4eaf2;
            height: 70px;
            .infoName {
              width: 170px;
              height: 72px;
              background-color: #f3faff;
              border-right: 1px solid #e4eaf2;
              font-size: 18px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: rgba(55, 58, 60, 1);
              padding-left: 30px;
              float: left;
              line-height: 72px;
            }
            .infoValue {
              float: left;
              display: flex;
              align-items: center;
              padding-left: 30px;
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(55, 58, 60, 1);
              height: 72px;
              width: 350px;
              line-height: 25px;
              .bussinessItem:nth-last-of-type(1) {
                b {
                  display: none;
                }
              }
            }
          }
          td:nth-of-type(2) {
            .infoName {
              width: 207px;
            }
          }
        }
      }
    }
  }
}
</style>